import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Vector = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M18.277 8c.347.596.985 1 1.723 1a2 2 0 000-4c-.738 0-1.376.404-1.723 1H16V4a1 1 0 00-1-1H9a1 1 0 00-1 1v2H5.723C5.376 5.404 4.738 5 4 5a2 2 0 000 4c.738 0 1.376-.404 1.723-1H8v.369C5.133 9.84 4.318 12.534 4.091 14H3a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1h-.877c.197-.959.718-2.406 2.085-3.418A.984.984 0 009 11h6a.98.98 0 00.792-.419c1.373 1.013 1.895 2.458 2.089 3.419H17a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1h-1.092c-.227-1.466-1.042-4.161-3.908-5.632V8h2.277zM6 18H4v-2h2v2zm14 0h-2v-2h2v2zm-6-9h-4V5h4v4z",
    key: "k0"
  }));
});
Vector.displayName = 'Vector';
export var VectorDimensions = {
  height: 24,
  width: 24
};